import { render, staticRenderFns } from "./DTMerchantDetail.vue?vue&type=template&id=09b66620"
import script from "./DTMerchantDetail.vue?vue&type=script&lang=js"
export * from "./DTMerchantDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports